import { render, staticRenderFns } from "./AccountLimit.vue?vue&type=template&id=0d54de60&scoped=true&"
import script from "./AccountLimit.vue?vue&type=script&lang=js&"
export * from "./AccountLimit.vue?vue&type=script&lang=js&"
import style0 from "./AccountLimit.vue?vue&type=style&index=0&id=0d54de60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d54de60",
  null
  
)

export default component.exports